import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';

export default class VisitorsSettingsIndexRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  redirect(): void {
    if (this.abilities.can('view visitor-types')) {
      void this.router.transitionTo('visitors.settings.visitor-types');
    } else if (this.abilities.can('configure host notifications')) {
      // Visitors > Settings > Notifications
      void this.router.transitionTo('visitors.settings.notifications');
    } else if (this.abilities.can('configure invites')) {
      // Visitors > Settings > Invites
      void this.router.transitionTo('visitors.settings.invites');
    } else if (this.abilities.can('visit security')) {
      // Visitors > Settings > Security
      void this.router.transitionTo('security');
    } else if (this.abilities.can('customize email for visitor-emails')) {
      // Visitors > Settings > Email templates
      void this.router.transitionTo('visitors.settings.email-templates');
    } else if (this.abilities.can('visit visitor-emails')) {
      // Visitors > Settings > Visitor emails
      void this.router.transitionTo('visitors.settings.visitor-emails');
    } else if (this.abilities.can('export all entries')) {
      void this.router.transitionTo('visitors.settings.location');
    } else {
      void this.router.transitionTo('unauthorized');
    }
  }
}
